import React, {forwardRef, useState} from 'react';
import PropTypes from 'prop-types';
import {
  Stack,
  IconButton,
  MinusCircleIcon,
  TextField,
  PlusCircleIcon
} from '@customink/pigment-react';
import './index.scss';

const NumberInput = forwardRef(
  (
    {
      value,
      onChange,
      name,
      error,
      autoFocus,
      incrementers,
      sx,
      'data-testid': testId
    },
    ref
  ) => {
    const [charWidth, setCharWidth] = useState(
      value === null ? 1 : String(value).length
    );
    const handleIncrement = () => onChange((value || 0) + 1);
    const handleDecrement = () => onChange((value || 0) - 1);
    const handleChange = e => {
      setCharWidth(String(e.target.value).length);
      onChange(parseInt(e.target.value, 10));
    };

    return (
      <Stack
        className="number-input"
        sx={{alignItems: 'center'}}
        direction="row">
        {incrementers && (
          <IconButton
            data-testid={`${testId}-decrement`}
            size="large"
            disabled={!value || value <= 1}
            onClick={handleDecrement}>
            <MinusCircleIcon fontSize="inherit" />
          </IconButton>
        )}

        <TextField
          name={name}
          type="tel"
          value={value || ''}
          onChange={handleChange}
          removeHelperTextSpace
          error={error}
          autoFocus={autoFocus}
          inputProps={{
            'data-testid': testId,
            sx: {
              fontSize: '32px !important',
              fontWeight: 700,
              lineHeight: '125%',
              textAlign: 'center',
              width: `${charWidth + 1}ch`, // min 1ch value
              minWidth: '70px', // min ~2ch width
              boxSizing: 'border-box',
              ...sx
            }
          }}
          inputRef={ref}
        />
        {incrementers && (
          <IconButton
            data-testid={`${testId}-increment`}
            size="large"
            onClick={handleIncrement}>
            <PlusCircleIcon fontSize="inherit" />
          </IconButton>
        )}
      </Stack>
    );
  }
);

NumberInput.displayName = 'NumberInput';

const propTypes = {
  autoFocus: PropTypes.bool,
  'data-testid': PropTypes.string,
  error: PropTypes.bool,
  incrementers: PropTypes.bool,
  name: PropTypes.string,
  sx: PropTypes.object,
  value: PropTypes.number,
  onChange: PropTypes.func
};

NumberInput.propTypes = propTypes;

export default NumberInput;
